import React from "react";
import { Wrapper } from "./CustomerListCardEntity.styled";
import { RightOutlined } from "@ant-design/icons";
import { getUserPermissions } from "utils/text";
import { useHistory } from "react-router";
import moment from "moment/moment.js";
import { Button, Row, Col, Tag, Empty } from "components/common";

const CustomerListCardEntity = ({ data }) => {
  const history = useHistory();
  let ProjectCreated =
  data?.dateCreated && moment(data?.dateCreated).format("MMM-DD-YYYY");
  let Created =
  data?.created && moment(data?.created).format("MMM-DD-YYYY");
  
  return (
    <Wrapper>
      <div className="main-container">
        <div style={{ width: "100%" }}>
          <div className="name-div">
            {/* <h5>Customer Name:</h5> */}
            <div className="flex-name">
              {data?.firstName ? (
                <h6>{data?.firstName} {data?.lastName}</h6>
              ) : (
                  <h6>{data?.customer_name}</h6>
              )}
            </div>
            <div className="flex-date">
              {ProjectCreated ? (
                <h6>{ProjectCreated}</h6>
              ) : (
                <h6>{Created}</h6>
              )}
            </div>
          </div>

          <div className="flex">
          {data?.city ? (
            <h6>
              {data?.city} {data?.street} {data?.state}
            </h6>
          ): (
            <h6>{data?.customer_city} {data?.customer_address}</h6>
          )}
            
          </div>
          <div className="flex-appoinment">
            <h6>
              {data?.appointmentTime && (
                <>
                  {" "}
                  Appointment On{" "}
                  {typeof data?.appointmentTime == "string" ? (
                    <>
                      {new Date(data?.appointmentTime).toLocaleString()}
                    </>
                  ) : (
                    <>
                      {new Date(
                        data?.appointmentTime?._seconds * 1000
                      ).toLocaleString()}
                    </>
                  )}
                </>
              )}
            </h6>
          </div>
          <div>
            {data?.date_cancelled != null && (
              <>
                <Tag color="#FFCCCC">AC</Tag>

                {data?.created != null && <Tag color="#FF9999">CON</Tag>}
                {data?.m1 != null && <Tag color="#FF7C80">SS</Tag>}
                {data?.m2 != null && <Tag color="#FF5050">Install</Tag>}
                {data?.ptoDate != null && <Tag color="#FF0000">PTO</Tag>}
                {data?.date_cancelled != null && (
                  <Tag color="#CC0000">Cancelled</Tag>
                )}
              </>
            )}
            {data?.date_cancelled === null || (
              <>
                <Tag color="#99D492">AC</Tag>
                {data?.created != null && <Tag color="#74C67A">CON</Tag>}
                {data?.m1 != null && <Tag color="#56B870">SS</Tag>}
                {data?.m2 != null && <Tag color="#39A96B">Install</Tag>}
                {data?.ptoDate != null && <Tag color="#1D9A6C">PTO</Tag>}
              </>
            )}
          </div>
        </div>
        {getUserPermissions("project-details-action") && (
          <div className="action-bar">
            <RightOutlined
              onClick={() => {
                history.push(`customer-details/${data?.objectID}`);
              }}
            />
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default CustomerListCardEntity;
